import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Back, like the app's goBack(fallback): the previous page when there is one
 * in this tab's history, else `fallback` (a page opened straight from a link
 * has nothing to go back to).
 */
export function useGoBack(fallback: string) {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(() => {
    // React Router gives the first page of a tab the key "default".
    if (location.key !== 'default') navigate(-1);
    else navigate(fallback, { replace: true });
  }, [navigate, location.key, fallback]);
}
